import React from 'react'

import './styles.scss'
const swatchSize = 12
export const Key = ({ entries }: { entries?: KeyEntryType[] }) => {
  if (!entries) {
    entries = [
      { type: 'line', label: 'Keyentry 1', color: '#f00' },
      { type: 'shape', label: 'Keyentry 2', color: '#00f' }
    ]
  }
  return (
    <div className='Key'>
      {entries.map((m, i) => {
        return (
          <div className='entry' key={'Key_' + i}>
            <div className='swatch'>
              {m.type === 'shape' ? (
                <SwatchShape color={m.color} />
              ) : m.type === 'line' ? (
                <SwatchLine color={m.color} />
              ) : (
                <SwatchNone />
              )}
            </div>
            <div className='label'>{m.label}</div>
          </div>
        )
      })}
    </div>
  )
}

const SwatchShape = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <rect width={swatchSize} height={swatchSize} fill={color} />
    </svg>
  )
}
const SwatchLine = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <line
        x2={swatchSize}
        y1={swatchSize}
        y2={0}
        stroke={color}
        strokeWidth={4}
      />
    </svg>
  )
}
const SwatchNone = () => {
  return <svg width={swatchSize} height={swatchSize}></svg>
}
